import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import add from '../imgs/icons/add.svg';
import remove from '../imgs/icons/delete.svg';
import arrowPurple from '../imgs/icons/arrowPurple.svg';
import SubregionCreationPopup from './SubregionCreationPopup';

const RegionTabGroup = ({
  selSelettore,
  defSelettore,
  mod,
  tabs,
  setTabs,
  tabConfig,
  sensorMounting,
  sensore,
  Region,
  renderInputXYZWithError,
  renderInputWithError,
  Subregions,
  renderSubregionInputWithError,
  setSubregion,
  setSubregionName,
  addSubregion,
  removeSubregion,
}) => {
  const renderRegionInputs = () => {
    if (sensorMounting === 'null') {
      return (
        <tr>
          <td colSpan="2">SETTARE MONTAGGIO SENSORE PRIMA DI MODIFICARE LE REGIONI</td>
        </tr>
      );
    }

    const inputsXYZ = [
      ['xMin', 'Xmin', 'xMax', 'Xmax'],
      ['yMin', 'Ymin', 'yMax', 'Ymax'],
      ['zMin', 'Zmin', 'zMax', 'Zmax'],
    ];
    const inputs = [
      ['sensorHeight', 'Altezza Sensore'],
      ['enterDuration', 'Durata Entrata'],
      ['exitDuration', 'Durata Uscita'],
    ];

    // ovveride 3 of them in case of Wall mounting
    const labelsOverride = sensorMounting === 0
      ? {
        xMax: 'Destra (Xmax)',
        xMin: 'Sinistra (Xmin)',
        yMax: 'Lunghezza (Ymax)',
      }
      : {};


    return (
      <>
        {inputsXYZ.map(([key1, label1, key2, label2]) => {
          return renderInputXYZWithError(
            key1,
            labelsOverride[key1] || label1,
            Region[key1],
            key2,
            labelsOverride[key2] || label2,
            Region[key2]
          );
        })}
        {inputs.map(([key, label]) =>
          renderInputWithError(key, label, Region[key])
        )}
      </>
    );

  };

  const [showSubregionPopup , setShowSubregionPopup ] = useState(false);

  const handlePopupClose = (value) => {
    if (value != null) {
      addSubregion(value);
    }
    setShowSubregionPopup(false);
  };



  const renderSubregionInputs = (subregion, index) => {
    const commonFields = (
      <>
        <tr>
          <td colSpan={2}>name</td>
          <td colSpan={3}>
            <input
              type="text"
              name="name"
              disabled={mod === 0}
              value={subregion.name}
              onChange={(e) => setSubregionName(e.target.value, index)}
            />
          </td>
        </tr>
        {[
          ['X', 'xMin', 'xMax'],
          ['Y', 'yMin', 'yMax'],
          ['Z', 'zMin', 'zMax']
        ].map(([label, minKey, maxKey]) => (
          renderSubregionInputWithError(label, minKey, maxKey, subregion, index)
        ))}
        <tr>
          <td colSpan={3}>Tempo di entrata</td>
          <td colSpan={2}>
            <input
              type="number"
              name="enterDuration"
              disabled={mod === 0}
              value={subregion.enterDuration}
              onChange={(e) => setSubregion(e.target.value, index, 'enterDuration')}
            />
          </td>
        </tr>
        <tr>
          <td colSpan={3}>Tempo di uscita</td>
          <td colSpan={2}>
            <input
              type="number"
              name="exitDuration"
              disabled={mod === 0}
              value={subregion.exitDuration}
              onChange={(e) => setSubregion(e.target.value, index, 'exitDuration')}
            />
          </td>
        </tr>
        {[
          ['isFallingDetection', 'Rileva Caduta'],
          ['isPresenceDetection', 'Rileva Occupazione'],
          ['isLowSnr', 'Zona riposo'],
          ['isHorizontal', 'Orizzontale'],
          ['isDoor', 'porta'],
        ].map(([key, label]) => (
          <tr key={key}>
            <td colSpan={3}>{label}</td>
            <td colSpan={2}>
              <Switch
                checked={!!subregion[key]}
                disabled={mod === 0}
                onClick={() => setSubregion(!subregion[key], index, key)}
              />
            </td>
          </tr>
        ))}
      </>
    );

    return (
      <div
        className="tabConfig subregion"
        key={`${sensore.deviceInfo.deviceId}_subregion_${index}`}
        id={`${sensore.deviceInfo.deviceId}subregion${index}`}
        style={{ maxHeight: '2.6em', flex: 1, flexDirection: 'row', display: 'flexbox', flexWrap: 'wrap' }}
      >
        <div className="headerStruttura" style={{ background: '#CDDEFF' }}>
          <div className="mini-tab mini-subregion">
            <div>
              <img
                src={arrowPurple}
                alt="arrow"
                id={`arrow${sensore.deviceInfo.deviceId}subregion${index}`}
                onClick={() => tabConfig(`${sensore.deviceInfo.deviceId}subregion${index}`)}
              />
              &emsp;{subregion.name}
            </div>
          </div>
          {mod === 1 && (
            <div className="mini-tab-add" onClick={() => removeSubregion(index)}>
              <img src={remove} alt="remove" />
            </div>
          )}
        </div>
        <table className="scheda" style={{ width: '90%' }}>
          <colgroup>
            <col style={{ width: "10%" }} />  {/* Label */}
            <col style={{ width: "10%" }} />  {/* "min:" or left label */}
            <col style={{ width: "35%" }} />  {/* min input */}
            <col style={{ width: "10%" }} />  {/* "max:" or right label */}
            <col style={{ width: "35%" }} />  {/* max input */}
          </colgroup>
          <tbody>{commonFields}</tbody>
        </table>
      </div>
    );
  };

  return (
    <div style={{ width: '20%', minHeight: '450px' }}>
      <div
        className={tabs === 0 ? selSelettore : defSelettore}
        onClick={() => setTabs(0)}
      >
        Regione
      </div>
      <div
        className={tabs === 1 ? selSelettore : defSelettore}
        onClick={() => setTabs(1)}
      >
        Sottoregioni
      </div>

      {((mod === 1) && (tabs === 1)) && (
        <>
          <button
            onClick={() => setShowSubregionPopup(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.3em',
              backgroundColor: '#e0e0ff',
              border: '1px solid #999',
              padding: '0.2em 0.5em',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.85em',
            }}
          >
            Aggiungi <img src={add} alt="add" style={{ height: '1em' }} />
          </button>

          {showSubregionPopup && (
            <SubregionCreationPopup onClose={handlePopupClose}>
              <p>Scegli sottoregione</p>
            </SubregionCreationPopup>
          )}
        </>
      )}

      {tabs === 0 ? (
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '1em',
          fontSize: '14px',
          border: '1px solid #ccc'
        }}>
          <colgroup>
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
          </colgroup>
          <tbody>{renderRegionInputs()}</tbody>
        </table>
      ) : (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
          <div style={{ height: 'calc(100vh - 150px)', display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                overflowY: 'auto',
                flexGrow: 1,
                padding: '0.5em'
              }}
            >
              {Array.isArray(Subregions) && Subregions.map((sr, i) => renderSubregionInputs(sr, i))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionTabGroup;
